var exports = {
  "kL": "x936d19a0--9fd266--container",
  "Kk": "x936d19a0--9fd266--icon",
  "Qq": "x936d19a0--9fd266--text",
};

module.exports = exports;
